import {
    ShieldCheck,
    BadgePercent,
    Hotel,
    Headphones,
    Check,
    Sparkles,
    Star,
} from "lucide-react";

import banner1 from "../assets/images/banner-bg1.jpg";
import banner2 from "../assets/images/banner-bg2.jpg";
import banner3 from "../assets/images/banner-bg3.jpg";

export default function WhyChooseUs() {

    const benefits = [
        "Verified luxury hotels across UAE",
        "Exclusive hotel deals and offers",
        "Secure and easy reservations",
        "24/7 customer assistance",
    ];


    return (

        <section className="pt-0 lg:pt-24 pb-24 bg-gray-50 dark:bg-gray-950">

            <div className="container mx-auto px-6">


                <div
                    className="
                        grid
                        lg:grid-cols-2
                        gap-14
                        items-center
                    "
                >


                    {/* Left Content */}

                    <div>


                        <span
                            className="
                                inline-flex
                                items-center
                                gap-2
                                px-5
                                py-2
                                rounded-full
                                bg-[#D9BB74]/20
                                text-[#0F766E]
                                dark:text-[#D9BB74]
                                text-sm
                                font-semibold
                                mb-5
                            "
                        >
                            <Sparkles size={16} />
                            Why Choose Us
                        </span>



                        <h2
                            className="
                                text-4xl
                                lg:text-5xl
                                font-bold
                                text-gray-900
                                dark:text-white
                                leading-tight
                                mb-5
                            "
                        >
                            Your Trusted Partner For
                            <span className="text-[#0F766E]">
                                {" "}UAE Hotel Stays
                            </span>
                        </h2>



                        <p
                            className="
                                text-gray-600
                                dark:text-gray-400
                                text-lg
                                leading-relaxed
                                mb-8
                            "
                        >
                            Experience premium stays with verified hotels,
                            exclusive offers, secure booking and dedicated
                            support across Dubai, Abu Dhabi and the UAE.
                        </p>




                        {/* Benefits */}

                        <div className="space-y-4 mb-10">


                            {benefits.map((item, index) => (

                                <div
                                    key={index}
                                    className="
                                        flex
                                        items-center
                                        gap-4
                                    "
                                >

                                    <div
                                        className="
                                            w-10
                                            h-10
                                            rounded-xl
                                            bg-[#D9BB74]
                                            flex
                                            items-center
                                            justify-center
                                        "
                                    >
                                        <Check
                                            size={18}
                                            className="text-[#1B1B1B]"
                                        />
                                    </div>


                                    <span
                                        className="
                                            text-gray-700
                                            dark:text-gray-300
                                            font-medium
                                        "
                                    >
                                        {item}
                                    </span>

                                </div>

                            ))}


                        </div>



                        {/* Mini Features */}

                        <div
                            className="
                                grid
                                grid-cols-3
                                gap-4
                            "
                        >

                            <div
                                className="
                                    rounded-2xl
                                    bg-white
                                    dark:bg-[#111827]
                                    p-4
                                    shadow-md
                                "
                            >
                                <Hotel
                                    className="text-[#0F766E] mb-2"
                                    size={22}
                                />

                                <p className="font-bold text-gray-900 dark:text-white">
                                    500+
                                </p>

                                <span className="text-xs text-gray-500">
                                    Hotels
                                </span>
                            </div>



                            <div
                                className="
                                    rounded-2xl
                                    bg-white
                                    dark:bg-[#111827]
                                    p-4
                                    shadow-md
                                "
                            >

                                <Star
                                    className="text-[#D9BB74] mb-2"
                                    size={22}
                                    fill="#D9BB74"
                                />

                                <p className="font-bold text-gray-900 dark:text-white">
                                    4.8
                                </p>

                                <span className="text-xs text-gray-500">
                                    Rating
                                </span>

                            </div>



                            <div
                                className="
                                    rounded-2xl
                                    bg-white
                                    dark:bg-[#111827]
                                    p-4
                                    shadow-md
                                "
                            >

                                <Headphones
                                    className="text-[#0F766E] mb-2"
                                    size={22}
                                />

                                <p className="font-bold text-gray-900 dark:text-white">
                                    24/7
                                </p>

                                <span className="text-xs text-gray-500">
                                    Support
                                </span>

                            </div>


                        </div>


                    </div>





                    {/* Right Image */}

                    <div
                        className="
                            relative
                        "
                    >


                        <div
                            className="
                                overflow-hidden
                                rounded-[40px]
                                shadow-2xl
                            "
                        >

                            <img
                                src={banner1}
                                alt="Luxury UAE Hotel"
                                className="
                                    w-full
                                    h-[550px]
                                    object-cover
                                "
                            />

                        </div>



                        {/* Floating Card */}

                        <div
                            className="
                                absolute
                                bottom-8
                                left-[-20px]
                                bg-white
                                dark:bg-[#111827]
                                rounded-3xl
                                p-5
                                shadow-xl
                            "
                        >

                            <div className="flex items-center gap-3">

                                <div
                                    className="
                                        w-12
                                        h-12
                                        rounded-xl
                                        bg-[#0F766E]
                                        flex
                                        items-center
                                        justify-center
                                    "
                                >
                                    <BadgePercent
                                        className="text-white"
                                    />
                                </div>


                                <div>

                                    <p className="
                                        font-bold
                                        text-gray-900
                                        dark:text-white
                                    ">
                                        Exclusive Deals
                                    </p>

                                    <span className="text-sm text-gray-500">
                                        Save more on UAE stays
                                    </span>

                                </div>

                            </div>

                        </div>


                    </div>


                </div>


            </div>

        </section>

    );
}